<div class="container">
    <div class="row no-gutters">
        <div class="col-12">
            <div class="d-flex popup-head align-items-center">
                <div class="popup-title mr-auto" translate>lblAddBrand</div>
                <div class="float-right">
                    <a class="close mr-3" (click)="OnClose()" translate>
                        <span class="" aria-hidden="true">&times;</span>
                    </a>
                </div>
            </div>
            <form #f="ngForm" (ngSubmit)="AddBrand(brandInfo)">
                <div class="card scrollbar">
                    <div class="card-content">
                        <div class="card-body">
                            <div class="form-row">
                                <div class="col-6 af-form-group">
                                    <label for="template-edit-model" translate>lblBrandCode<strong
                                            class="mlt6 required"> * </strong>
                                    </label>
                                    <div class="lbl-info">
                                        <input type="text" id="template-edit-model" name="model" #model="ngModel" 
                                            class="form-control" [(ngModel)]="brandInfo.brandCode" required
                                            maxlength="15" [ngClass]="{'is-invalid': model.invalid && model.touched}">
                                        <div *ngIf="model.invalid && (model.dirty || model.touched)"
                                            class="help-block text-danger">
                                            <div *ngIf="model.errors.required"><span
                                                    translate>lblBrandCodeRequired</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-6 af-form-group">
                                    <label for="template-edit-company" translate>lblBrandName<strong
                                            class="mlt6 required"> * </strong>
                                    </label>
                                    <div class="lbl-info">
                                        <input type="text" id="template-edit-model" name="Companybrand"
                                            #Companybrand="ngModel" class="form-control"
                                            [(ngModel)]="brandInfo.brandName" required maxlength="25"
                                            [ngClass]="{'is-invalid': Companybrand.invalid && Companybrand.touched}">
                                        <div *ngIf="Companybrand.invalid && (Companybrand.dirty || Companybrand.touched)"
                                            class="help-block text-danger">
                                            <div *ngIf="Companybrand.errors.required"><span
                                                    translate>lblBrandNameRequired</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-6 col-xl-3 af-form-group">
                                    <div class='lbl-info'>
                                        <div>
                                            <label class="btn btn-outline-primary d-inline-block" for="select-files"
                                                translate>lblUploadLogo</label>
                                            <input type="file" id="select-files" name="image" #image="ngModel" ngModel
                                                (change)="onChangeFileUpload($event.target.files)"
                                                accept=".png, .jpg, .jpeg .svg"
                                                [ngClass]="{'is-invalid': image.invalid && image.touched}" hidden
                                                required>
                                            <p class="text-muted">
                                                <span translate class="fnt10">lblNote</span><span class="fnt10">:
                                                </span><span translate class="fnt10">lblFileSizeLessThan100KB</span>
                                            </p>
                                            {{imageName}}<br>
                                            <img *ngIf="ImageBinaryData" [src]="ImageBinaryData | safe: 'url'"
                                                id="UploadImage"
                                                onError="this.onerror=null; this.src='../../../../../assets/images/no-image-icon.png'"
                                                alt="image does not found." class="carimg border mt-2 p-2">
                                            <div *ngIf="image.invalid && (image.dirty || image.touched)"
                                                class="help-block text-danger">
                                                <div *ngIf="image.errors.required"><span
                                                        translate>lblImageRequired</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 af-form-group">
                                    <div class="lbl-info">
                                        <div class="custom-control custom-switch">
                                            <input class="custom-control-input" #isActive id="isActive" type="checkbox"
                                                [checked]="brandInfo.isActive" (change)="onChange(isActive.checked)" />
                                            <label class="custom-control-label" for="isActive"
                                                translate>lblActive</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="p-3 bg-light">
                    <div class="row">
                        <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mb15">
                            <button type="submit" class="btn btn-primary btn-lg  mr-sm-2"
                                [disabled]="!f.valid || !isValidImg" translate aria-label="Center Align"><em class="fa fa-plus font16 align-top mr-2"></em> lblAdd</button>
                            <a (click)="OnClose()" class="btn btn-secondary btn-lg" translate><em class="far fa-times-circle font16 align-top mr-2"></em> lblCancel</a>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>